(function () {
  'use strict';

  var instances = new Map();

  function HeroSlideshow(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.menuToggle = root.querySelector('[data-hero-menu-toggle]');
    this.menuPanel = root.querySelector('[data-hero-menu-panel]');
    this.currentIndex = 0;
    this.selectedByEditor = false;
    this.controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

    this.init();
  }

  HeroSlideshow.prototype.signal = function () {
    return this.controller ? this.controller.signal : undefined;
  };

  HeroSlideshow.prototype.init = function () {
    var self = this;
    var signal = this.signal();

    this.slides.forEach(function (slide, index) {
      var video = slide.querySelector('[data-hero-slide-video]');
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;

      if (index === self.currentIndex) {
        self.attemptVideoPlay(video, signal);
      } else {
        video.pause();
      }

      video.addEventListener('ended', function () {
        if (self.selectedByEditor) return;
        self.goTo(1, false);
      }, { signal: signal });
    });

    if (this.menuToggle && this.menuPanel) {
      this.menuToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        self.toggleMenu();
      }, { signal: signal });

      Array.prototype.slice.call(this.menuPanel.querySelectorAll('a')).forEach(function (link) {
        link.addEventListener('click', function () {
          self.closeMenu();
        }, { signal: signal });
      });

      document.addEventListener('click', function (event) {
        if (!self.menuPanel.classList.contains('is-open')) return;
        if (root.contains(event.target)) return;
        self.closeMenu();
      }, { signal: signal });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') self.closeMenu();
      }, { signal: signal });
    }
  };

  HeroSlideshow.prototype.toggleMenu = function (force) {
    if (!this.menuToggle || !this.menuPanel) return;
    var open = typeof force === 'boolean' ? force : !this.menuPanel.classList.contains('is-open');
    this.menuPanel.classList.toggle('is-open', open);
    this.menuToggle.setAttribute('aria-expanded', String(open));
  };

  HeroSlideshow.prototype.closeMenu = function () {
    this.toggleMenu(false);
  };

  HeroSlideshow.prototype.goTo = function (direction, isManual) {
    if (this.slides.length < 2) return;

    var current = this.slides[this.currentIndex];
    this.setSlideActive(current, false);

    this.currentIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length;

    var next = this.slides[this.currentIndex];
    this.setSlideActive(next, true);
  };

  HeroSlideshow.prototype.setSlideActive = function (slide, active) {
    if (!slide) return;
    slide.classList.toggle('is-active', active);

    var video = slide.querySelector('[data-hero-slide-video]');
    if (!video) return;

    if (active) {
      video.currentTime = 0;
      this.attemptVideoPlay(video, this.signal());
    } else {
      video.pause();
    }
  };

  HeroSlideshow.prototype.attemptVideoPlay = function (video, signal) {
    var playPromise = video.play();
    if (!playPromise || !playPromise.catch) return;

    playPromise.catch(function () {
      // Autoplay was blocked (e.g. iOS Low Power Mode) — start on the
      // user's first tap/click anywhere on the page instead of requiring
      // them to press the video's own native play button.
      var resume = function () {
        video.muted = true;
        video.play().catch(function () {});
      };
      document.addEventListener('touchstart', resume, { once: true, passive: true, signal: signal });
      document.addEventListener('click', resume, { once: true, signal: signal });
    });
  };

  HeroSlideshow.prototype.goToIndex = function (index) {
    if (index < 0 || index >= this.slides.length || index === this.currentIndex) return;
    var current = this.slides[this.currentIndex];
    this.setSlideActive(current, false);
    this.currentIndex = index;
    this.setSlideActive(this.slides[index], true);
  };

  HeroSlideshow.prototype.destroy = function () {
    if (this.controller) this.controller.abort();
  };

  function initAll(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-hero-slideshow]');
    roots.forEach(function (root) {
      var sectionId = root.dataset.sectionId;
      if (instances.has(sectionId)) return;
      instances.set(sectionId, new HeroSlideshow(root));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-hero-slideshow]') : null;
    if (!root) return;
    var sectionId = root.dataset.sectionId;
    var instance = instances.get(sectionId);
    if (instance) {
      instance.destroy();
      instances.delete(sectionId);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest ? event.target.closest('[data-hero-slide]') : null;
    if (!slide) return;
    var root = slide.closest('[data-hero-slideshow]');
    if (!root) return;
    var instance = instances.get(root.dataset.sectionId);
    if (!instance) return;
    instance.selectedByEditor = true;
    var index = parseInt(slide.dataset.slideIndex, 10);
    instance.goToIndex(index);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var slide = event.target.closest ? event.target.closest('[data-hero-slide]') : null;
    if (!slide) return;
    var root = slide.closest('[data-hero-slideshow]');
    if (!root) return;
    var instance = instances.get(root.dataset.sectionId);
    if (instance) instance.selectedByEditor = false;
  });
})();
